import React from "react"
import styled from "styled-components"
import banerBgImg from "../images/banner-bg.jpg"

const StyledWrapper = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-image: url(${({ src }) => src});
  background-size: cover;

  @media (max-width: 414px) {
    background-size: cover;
  }
`
const StyledTitle = styled.h1`
  font-family: "Blogger Sans", Times, serif;
  font-weight: 500;
  font-size: 58px;
  color: white;
  margin-top: 10px;
  line-height: 1.5;

  @media (max-width: 1024px) {
    font-size: 46px;
  }

  @media (max-width: 414px) {
    font-size: 25px;
    line-height: 1.2;
  }
`

const StyledSubTitle = styled.div`
  font-size: 32px;
  font-family: "Blogger Sans", Times, serif;
  font-weight: 300;
  color: white;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    font-size: 26px;
    margin-bottom: 16px;
  }

  @media (max-width: 414px) {
    font-size: 14px;
    margin-bottom: 16px;
  }
`
const IconWrapper = styled.div`
  width: 30px;
  height: 30px;
  background: ${({ secondary }) => (secondary && "white") || "#00399f"};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 35px;

  svg {
    color: ${({ secondary }) => (secondary && "#00399f") || "white"};
    font-size: 16px;
  }

  @media (max-width: 414px) {
    font-size: 14px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    right: 15px;
  }
`
const StyledRegisterButton = styled.button`
  font-size: 25px;
  font-family: "Blogger Sans", Times, serif;
  color: #00399f !important;
  text-transform: uppercase;
  padding: 16px 85px 14px 35px;
  font-weight: 900;
  border: 2px solid white;
  background: white;
  transition: 0.5s;
  cursor: pointer;
  position: relative;

  :hover {
    background: #00399f;
    border-color: white;
    color: white !important;

    ${IconWrapper} {
      transition: 0.5s;
      background: white;

      svg {
        color: #00399f;
      }
    }
  }

  @media (max-width: 1024px) {
    font-size: 22px;
  }

  @media (max-width: 414px) {
    font-size: 18px;
    padding: 8px 60px 8px 15px;
  }
`

const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 414px) {
    margin-top: 20px;
  }
`

const HeaderCTA = () => {
  return (
    <StyledWrapper src={banerBgImg}>
      <div>
        <StyledTitle>
          Korzyści z przejścia do chmury Azure - case study <br />
          SITA FOR AIRCRAFT
        </StyledTitle>
        <StyledSubTitle>
          Webinar odbył się 9 czerwca 2020. <br />
          Wkrótce poinformujemy o nowych wydarzeniach.
        </StyledSubTitle>
      </div>
    </StyledWrapper>
  )
}

export default HeaderCTA
